/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type RenderInvoiceEmailInput = {
    readonly transactionId: string;
    readonly message?: string | null;
    readonly recipientEmails: ReadonlyArray<string | null>;
    readonly senderEmail: string;
    readonly senderName: string;
    readonly clientMutationId?: string | null;
};
export type RenderInvoiceEmailMutationVariables = {
    readonly input: RenderInvoiceEmailInput;
};
export type RenderInvoiceEmailMutationResponse = {
    readonly renderInvoiceEmail: {
        readonly clientMutationId: string | null;
    } | null;
};
export type RenderInvoiceEmailMutation = {
    readonly response: RenderInvoiceEmailMutationResponse;
    readonly variables: RenderInvoiceEmailMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "RenderInvoiceEmailInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "renderInvoiceEmail",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RenderInvoiceEmailPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clientMutationId",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "RenderInvoiceEmailMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "RenderInvoiceEmailMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "RenderInvoiceEmailMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/RenderInvoiceEmailMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '788da53b838595b4d07bea930350a054';
export default node;
